// UI
import MillionsIcon from 'ui3/MillionsIcon/MillionsIcon';
// Styles
import styles from './NotificationIconWithNumber.module.scss';

type NotificationIconWithNumberProps = {
  hasUnread: boolean;
};

const NotificationIconWithNumber = ({
  hasUnread,
}: NotificationIconWithNumberProps) => {
  return (
    <div className={styles.container}>
      <MillionsIcon className={styles.icon} name="notificationBell" />

      {hasUnread && <div className={styles.actionDot} />}
    </div>
  );
};

export default NotificationIconWithNumber;
